import { Injectable } from "@angular/core";
import { ProductConfiguration } from "@domain/project/configurations/product-configuration";
import { AirPathDirection } from "@domain/project/floorplan/air-path";
import { DustExZoneType } from "@domain/project/floorplan/zones/dust-ex-zone";
import { ExZoneType } from "@domain/project/floorplan/zones/ex-zone";
import { WildcardZoneType } from "@domain/project/floorplan/zones/wildcard-zone";
import { ProjectImageMetadata } from "@domain/project/project-image-metadata";
import { Observable, Subject } from "rxjs";

export enum DraggedItemType {
  GAS_WARNING_CENTER = "GAS_WARNING_CENTER",
  TRANSMITTER = "TRANSMITTER",
  FLAME_DETECTOR = "FLAME_DETECTOR",
  SIGNAL_ELEMENT = "SIGNAL_ELEMENT",
  PLASTIC_SIGN = "PLASTIC_SIGN",
  ALARM_DEVICE = "ALARM_DEVICE",
  GAS_WARNING_CENTER_PLACEHOLDER = "GAS_WARNING_CENTER_PLACEHOLDER",
  TRANSMITTER_PLACEHOLDER = "TRANSMITTER_PLACEHOLDER",
  FLAME_DETECTOR_PLACEHOLDER = "FLAME_DETECTOR_PLACEHOLDER",
  SIGNAL_ELEMENT_PLACEHOLDER = "SIGNAL_ELEMENT_PLACEHOLDER",
  PLASTIC_SIGN_PLACEHOLDER = "PLASTIC_SIGN_PLACEHOLDER",
  ALARM_DEVICE_PLACEHOLDER = "ALARM_DEVICE_PLACEHOLDER",
  PIPELINE = "PIPELINE",
  CABLE_ROUTE = "CABLE_ROUTE",
  PROTECTIVE_TUBE = "PROTECTIVE_TUBE",
  WIRE = "WIRE",
  MEASUREMENT_LINE = "MEASUREMENT_LINE",
  REFERENCE_MEASURE = "REFERENCE_MEASURE",
  NOTES = "NOTES",
  FREE_TEXT = "FREE_TEXT",
  DANGER_AREA = "DANGER_AREA",
  IMAGE = "IMAGE",
  EX_ZONE = "EX_ZONE",
  DUST_EX_ZONE = "DUST_EX_ZONE",
  WILDCARD_ZONE = "WILDCARD_ZONE",
  EXHAUST_AIR = "EXHAUST_AIR",
  SUPPLY_AIR = "SUPPLY_AIR",
  PATIENT_MONITOR = "PATIENT_MONITOR",
  PATIENT_MONITOR_PLACEHOLDER = "PATIENT_MONITOR_PLACEHOLDER",
  CENTRAL_STATION = "CENTRAL_STATION",
  CENTRAL_STATION_PLACEHOLDER = "CENTRAL_STATION_PLACEHOLDER",
  TELEMETRY = "TELEMETRY",
  TELEMETRY_PLACEHOLDER = "TELEMETRY_PLACEHOLDER",
  KVM = "KVM",
  KVM_PLACEHOLDER = "KVM_PLACEHOLDER",
  DISPLAY = "DISPLAY",
  DISPLAY_PLACEHOLDER = "DISPLAY_PLACEHOLDER",
  UTILITY = "UTILITY",
  UTILITY_PLACEHOLDER = "UTILITY_PLACEHOLDER",
  ISOLATION_ROOM = "ISOLATION_ROOM",
  IT_ROOM = "IT_ROOM",
  OPERATING_THEATRE = "OPERATING_THEATRE",
  PROCEDURE_ROOM = "PROCEDURE_ROOM",
  STANDARD_ROOM = "STANDARD_ROOM",
}

export interface DraggedItem {
  type: DraggedItemType;
  config?: ProductConfiguration | ProjectImageMetadata | ExZoneType | DustExZoneType | WildcardZoneType | AirPathDirection;
  freeTextPlaceholder?: string;
}

export interface DropPosition {
  x: number;
  y: number;
}

export interface DropEvent {
  dropPosition: DropPosition;
  draggedItem: DraggedItem;
}

@Injectable({ providedIn: "root" })
export class FloorplanDragDropService {
  private draggedItem: DraggedItem | undefined;

  private dropSubject = new Subject<DropEvent>();

  get dropSubject$(): Observable<DropEvent> {
    return this.dropSubject.asObservable();
  }

  publishDropEvent(dropPosition: DropPosition) {
    if (this.draggedItem) {
      const dropEvent: DropEvent = { dropPosition: dropPosition, draggedItem: this.draggedItem };
      this.dropSubject.next(dropEvent);
    }
  }

  setDragged(obj: DraggedItem) {
    this.draggedItem = obj;
  }

  clear() {
    this.draggedItem = undefined;
  }
}
